import Marquee from "react-fast-marquee";
import { SECTORS } from "../data/content";

export default function SectorMarquee() {
  return (
    <div data-testid="sector-marquee" className="border-y border-white/10 py-8 md:py-10 bg-[#080808]">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {SECTORS.map((s, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-6xl font-black tracking-tight text-white/90 px-8">
              {s.name}
            </span>
            <span className="text-accent text-3xl md:text-5xl">&bull;</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
